import React, { useEffect, useRef } from "react";
import createGlobe from "cobe";
import { motion } from "framer-motion";

export const SkeletonOne = () => (
  <div className="flex items-center justify-center h-full p-4">
    <motion.img
      src="/assets/mission-workspace.jpg"
      alt="Mission Workspace"
      className="object-cover w-3/4 h-auto rounded-lg"
      whileHover={{ scale: 1.05 }}
    />
  </div>
);

export const SkeletonTwo = () => {
  const images = [
    "/assets/ai-visual-1.jpg",
    "/assets/ai-visual-2.jpg",
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full gap-8 p-6"> {/* Added more padding */}
      {images.map((src, idx) => (
        <motion.div
          key={idx}
          className="rounded-lg overflow-hidden w-3/4 h-auto flex-shrink-0"
          whileHover={{ scale: 1.1 }}
        >
          <img
            src={src}
            alt={`AI Visual ${idx + 1}`}
            className="object-cover w-full h-auto rounded-lg"
          />
        </motion.div>
      ))}
    </div>
  );
};

export const SkeletonThree = () => (
  <motion.div
    className="relative group flex items-center justify-center h-full p-4"
    whileHover={{ scale: 1.05 }}
  >
    <img
      src="/assets/card-vision2.png"  // Replace with your actual image file
      alt="Alternative Representation"
      className="object-cover w-3/4 h-auto rounded-lg"
    />
  </motion.div>
);

export const SkeletonFour = () => {
  const canvasRef = useRef();

  useEffect(() => {
    let phi = 0;

    if (!canvasRef.current) return;

    const globe = createGlobe(canvasRef.current, {
      devicePixelRatio: 2,
      width: 600, 
      height: 600,
      phi: 0,
      theta: 0.3,
      dark: 1,
      diffuse: 1.2,
      mapSamples: 16000,
      mapBrightness: 6,
      baseColor: [0.3, 0.3, 0.3],
      glowColor: [1, 1, 1],
      markerColor: [0.1, 0.8, 1],
      markers: [
        { location: [37.7749, -122.4194], size: 0.03 },
        { location: [40.7128, -74.0060], size: 0.1 },
        { location: [51.5074, -0.1278], size: 0.1 },
        { location: [35.6895, 139.6917], size: 0.05 },
        { location: [48.8566, 2.3522], size: 0.07 },
        { location: [-33.8688, 151.2093], size: 0.05 },
        { location: [55.7558, 37.6173], size: 0.06 },
        { location: [-23.5505, -46.6333], size: 0.08 },
        { location: [28.6139, 77.2090], size: 0.06 },
        { location: [34.0522, -118.2437], size: 0.07 },
        { location: [-17.8252, 31.0335], size: 0.05 },
        { location: [6.5244, 3.3792], size: 0.06 },
      ],
      onRender: (state) => {
        state.phi = phi;
        phi += 0.01;
      },
    });

    return () => globe.destroy();
  }, []);

  return (
    <motion.div
      className="flex justify-center items-center"
      whileHover={{ scale: 1.05 }}
    >
      <canvas
        ref={canvasRef}
        style={{ width: "300px", height: "300px", maxWidth: "100%" }}
        className="rounded-lg"
      ></canvas>
    </motion.div>
  );
};




